import { Navigator } from '../../../../effects/navigator';
import { CallActions } from '../../../../store/call/actions';
import { CallSelectors } from '../../../../store/call/selectors';
import { AppThunk } from '../../../../store/types';

export class PreviewEvents {

	public static onOpen(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			Navigator.openCall();
		}
	}

	public static onLeave(
	): AppThunk {
		return async (
			dispatch,
			getState
		) => {
			if (CallSelectors.getIsActive(getState())) {
				dispatch(CallActions.update({isActive: false}));
			}
		}
	}

}
